import {NgModule} from '@angular/core';
import {HeaderComponent} from './header/header.component';
import {HomeComponent} from './home/home.component';
import {AppRoutingModule} from '../app-routing.module';
import {SharedModule} from '../shared/shared.module';
import {NotificationsService, SimpleNotificationsModule} from 'angular2-notifications';
import {ApiMessageService} from './api-message.service';
import {DropdownNavbarComponent} from './header/dropdown/dropdown-navbar.component';
import {BadRequestComponent} from './badrequest/badrequest.component';
import {ConfigService} from './config.service';
import {NavigationService} from './navigation.service';
import {AuthModule} from '../auth/auth.module';
import {MenuService} from './header/menu.service';
import { NgxCnrUictSsoModule } from 'ngx-cnr-uict-sso';


/**
 * Nel core module inserisco tutti i components necessari all'avvio dell'applicazione.
 * Esempio Pagina Iniziale ed Header.
 * Deve essere importato esclusivamente da AppModule.
 *
 * Questo modulo inoltre fornisce l'istanza di tutti quei servizi singleton necessari all'applicazione
 * Esempio: notificationService, apiMessageService.
 */
@NgModule({

  declarations: [
    HeaderComponent,
    DropdownNavbarComponent,
    HomeComponent,
    BadRequestComponent
  ],

  imports: [
    AppRoutingModule,
    SharedModule,                       // Componenti condivisi da tutta l'applicazione (ex. Tags).
    AuthModule,
    NgxCnrUictSsoModule,
    SimpleNotificationsModule.forRoot() // Le notifiche (per ora) vengono tutte generate nell'header component.
  ],

  exports: [
    AuthModule,
    SharedModule,

    HomeComponent,
    HeaderComponent,
    BadRequestComponent
  ],

  providers: [
    // Capire il discorso del root-injector e child-injector.
    ApiMessageService,
    NotificationsService,
    ConfigService,
    NavigationService,
    MenuService
  ]
})
export class CoreModule {}
